const normalizeRegistrationSaveResult = (saveResult) => {
  if (!saveResult.ok) {
    return {
      ok: false,
      errorMessage: saveResult.errorText,
      status: saveResult.status,
      statusText: saveResult.statusText,
    };
  }

  const savedRegistration = saveResult.data;

  return {
    ok: true,
    savedRegistration,
    registrationId: savedRegistration.registrationId,
    registrationDbId: savedRegistration.dbId || savedRegistration.id,
  };
};

const saveRegistrationForPaymentFlow = async ({
  conferenceRegistrationUrl,
  payload,
  formData,
  saveConferenceRegistration,
  forceCreate = false,
}) => {
  const isUpdate = !!(formData.id || formData.regId);
  const registrationIdForUpdate = formData.regId || formData.id;

  const saveResult = await saveConferenceRegistration({
    conferenceRegistrationUrl,
    registrationId: !forceCreate && isUpdate ? registrationIdForUpdate : null,
    payload,
    ...(forceCreate ? { forceCreate: true } : {}),
  });

  return normalizeRegistrationSaveResult(saveResult);
};



// const saveRegistrationForPaymentFlow = async ({
//   conferenceRegistrationUrl,
//   payload,
//   formData,
//   saveConferenceRegistration,
//   forceCreate = false,
// }) => {
//   // formData.id is the conference registration ID.
//   // formData.regId is only the database ID.
//   const registrationIdForUpdate = formData.id;

//   // Never use the database ID as the registration URL ID.
//   if (!forceCreate && !registrationIdForUpdate && formData.regId) {
//     return {
//       ok: false,
//       errorMessage:
//         "Registration ID is missing. A database ID exists, but it cannot be used as the registration ID. Please verify the existing registration before proceeding.",
//       status: 409,
//       statusText: "Registration ID mismatch",
//     };
//   }

//   const saveResult = await saveConferenceRegistration({
//     conferenceRegistrationUrl,
//     registrationId: !forceCreate
//       ? registrationIdForUpdate || null
//       : null,
//     payload,
//     ...(forceCreate ? { forceCreate: true } : {}),
//   });

//   return normalizeRegistrationSaveResult(saveResult);
// };


export const saveRegistrationBeforePayment = async ({
  conferenceRegistrationUrl,
  payload,
  formData,
  saveConferenceRegistration,
}) => {
  console.log("🔄 Payment flow registration save (NEW registration):");
  console.log(
    "  formData.id (registrationId):",
    formData.id,
    "← NULL, so doing POST"
  );
  console.log(
    "  formData.regId (dbId):",
    formData.regId,
    "← IGNORED in this flow"
  );
  console.log("  Method:", "POST");
  console.log("  URL:", conferenceRegistrationUrl);

  const result = await saveRegistrationForPaymentFlow({
    conferenceRegistrationUrl,
    payload,
    formData,
    saveConferenceRegistration,
    forceCreate: true,
  });

  if (result.ok) {
    console.log("💾 Registration saved response:");
    console.log("  savedReg.registrationId:", result.savedRegistration.registrationId);
    console.log("  savedReg.dbId:", result.savedRegistration.dbId);
    console.log("  savedReg.id:", result.savedRegistration.id);
    console.log("  Using registrationId:", result.registrationId);
    console.log("  Using registrationDbId:", result.registrationDbId);
  }

  return result;
};

export const ensureRegistrationForFailedPayment = async ({
  conferenceRegistrationUrl,
  payload,
  formData,
  saveConferenceRegistration,
}) => {
  return saveRegistrationForPaymentFlow({
    conferenceRegistrationUrl,
    payload,
    formData,
    saveConferenceRegistration,
  });
};

export const ensureRegistrationForPaymentHandler = async ({
  conferenceRegistrationUrl,
  payload,
  formData,
  saveConferenceRegistration,
}) => {
  return saveRegistrationForPaymentFlow({
    conferenceRegistrationUrl,
    payload,
    formData,
    saveConferenceRegistration,
  });
};
